import comp from "./ScoreAssessmentTool";
export default comp;
